import {jt, t} from 'ttag';

const PlanChangeFooter = () => {
    // LINK HREF NOT IMPLEMENTED
    const limitedUseLink = <a href="/">{t`limited use`}</a>;

    // LINK HREF NOT IMPLEMENTED
    const charitiesLink = <a href="/">{t`charities`}</a>;

    return (
        <div className="flex w-full items-center justify-center whitespace-pre border-y border-grey-100 py-4 text-sm">
            {jt`Free for ${limitedUseLink}. 20% off available for ${charitiesLink} on request.`}
        </div>
    );
};

export default PlanChangeFooter;
